import { useState, useEffect } from 'react'

export interface GameState {
  last_played: string
  streak: number
  games: {
    daily_word?: GameResult
    pic_reveal?: GameResult
    rank_rush?: GameResult
  }
  version: string
}

export interface GameResult {
  status: 'won' | 'lost' | 'pending'
  tries?: number
  attempts?: number
  guesses?: string[]
}

const STORAGE_KEY = 'dailyguess_state'

const DEFAULT_STATE: GameState = {
  last_played: '',
  streak: 0,
  games: {},
  version: 'v1'
}

export function useGameState() {
  const [state, setState] = useState<GameState>(DEFAULT_STATE)

  useEffect(() => {
    // Load from localStorage on mount
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try {
        setState(JSON.parse(stored))
      } catch (e) {
        console.error('Failed to parse game state:', e)
      }
    }
  }, [])

  const updateState = (updates: Partial<GameState>) => {
    setState((prev) => {
      const newState = { ...prev, ...updates }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newState))
      return newState
    })
  }

  return { state, updateState }
}

